import { useEffect, useMemo, useState } from "react"
import { useFilter } from "../../../context/FIlterContext"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";

export const useCardWidget = () => {

    const { projectFilter, setProjectFilter } = useFilter();
    const [cardsData, setCardsData] = useState(null)


    useEffect(() => {
        if (projectFilter?.apiCall) {
            getCardSummaryData();
        }
    }, [projectFilter?.apiCall]);


    const getCardSummaryData = async () => {
        try {
            const payload = {
                "client_id": projectFilter?.client_id?.client_id || 0,
                "project_ids": _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                "lead_user_code": projectFilter?.lead_user_code?.user_code || 0,
                "request_user_code": projectFilter?.request_user_code || 0,
                "project_module_ids": _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                "feature_ids": _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                "issue_key": projectFilter?.issue_id,
            }
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTCARDSUMMARY'), payload)
            if (res?.status === 200) {
                const data = res?.body?.data
                const totalObj = _.findWhere(data?.card_projects, { project_status_key: 'total' });
                const labelArr = _.filter(data?.card_projects, item => item.project_status_key !== 'total');
                const labelString = _.map(labelArr, item => (
                    `${item.project_status_name}: ${item.total_projects}`
                )).join(' | ');

                const ProjectObj = {
                    total: totalObj ? totalObj.total_projects : 0,
                    label: labelString
                };
                setCardsData({
                    card_projects: ProjectObj,
                    card_employees: data?.card_employees?.[0],
                    card_clients: data?.card_clients?.[0],
                    card_worklogs: data?.card_worklogs?.[0]
                })
                setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            console.error('Error :', error);
        }
    }

    return useMemo(() => ({
        cardsData
    }), [cardsData])
}